import { useContext } from "react";
import { SocketContext } from "../contexts/useSubscriptions";

const UseTransformationCloneComplete = () => {
  const { stCloneComplete, setStCloneComplete } = useContext(SocketContext);

  return { stCloneComplete, setStCloneComplete };
};

export default UseTransformationCloneComplete;
